import { IOrderFilterTileOption } from '../models/purchase-history/order-filter';

export const dateTileOptions = [
  { value: 'last30Days', label: 'Last 30 Days' },
  { value: 'last90Days', label: 'Last 90 Days' },
  { value: 'last6Months', label: 'Last 6 Months' },
  { value: 'last25Months', label: 'Last 25 Months' },
  { value: 'thisYear', label: new Date().getFullYear().toString() },
  { value: 'lastYear', label: (new Date().getFullYear() - 1).toString() },
  { value: 'twoYearsPrior', label: (new Date().getFullYear() - 2).toString() },
  {
    value: 'threeYearsPrior',
    label: (new Date().getFullYear() - 3).toString(),
  },
  { value: 'fourYearsPrior', label: (new Date().getFullYear() - 4).toString() },
  { value: 'fiveYearsPrior', label: (new Date().getFullYear() - 5).toString() },
  { value: 'sixYearsPrior', label: (new Date().getFullYear() - 6).toString() },
];

export const userTileOptions = (username: string) => [
  { value: 'allOrders', label: 'Everyone' },
  { value: 'myOrders', label: `${username ?? ''} (Just Me)` },
];

export const poJobNameTileOptions: IOrderFilterTileOption[] = [
  { value: 'Job Site 123' },
  { value: 'Kitchen Remodel' },
  { value: 'Warehouse Restock' },
];

export const paymentTileOptions: IOrderFilterTileOption[] = [
  { value: '1111' },
  { value: '2222' },
  { value: '3333' },
  { value: '4444' },
  { value: '5555' },
  { value: '6666' },
  { value: '7777' },
  { value: '8888' },
  { value: '9999' },
  { value: '0000' },
  { value: '1001' },
  { value: '1002' },
  { value: '1003' },
  { value: '1004' },
  { value: '1005' },
  { value: '1006' },
  { value: '1007' },
  { value: '1008' },
  { value: '1009' },
  { value: '1010' },
  { value: '1011' },
  { value: '1012' },
  { value: '1013' },
  { value: '1014' },
  { value: '1015' },
  { value: '1016' },
  { value: '1017' },
  { value: '1018' },
  { value: '1019' },
  { value: '1020' },
  { value: '1021' },
  { value: '1022' },
  { value: '1023' },
  { value: '1024' },
  { value: '1025' },
  { value: '1026' },
  { value: '1027' },
  { value: '1028' },
  { value: '1029' },
  { value: '1030' },
  { value: '1031' },
  { value: '1032' },
  { value: '1033' },
  { value: '1034' },
  { value: '1035' },
  { value: '1036' },
  { value: '1037' },
  { value: '1038' },
  { value: '1039' },
  { value: '1040' },
];
